export const environment = {
  production: false,
  API_URL: "https://api.homesellersavings.com/api/",
};
